import { compose, branch, renderNothing } from 'react-recompose';

import withReduxConnect from '~/views/enhancers/withReduxConnect.js';
import withReduxDataLoading from './withReduxDataLoading.js';

import { isAuthenticated } from '~/state/ducks/auth/selectors.js';
import { fetchAppData } from '~/state/ducks/app/operations.js';


const withFetchAppData = compose(
    withReduxDataLoading({
        name: 'fetchAppData',
        operation: fetchAppData,
    }),
    branch(({ isLoading, isLoadingFail }) => isLoading || isLoadingFail, renderNothing),
);

export default compose(
    withReduxConnect({
        mapStateToProps: state => ({
            isAuthenticated: isAuthenticated(state),
        }),
    }),
    branch(({ isAuthenticated }) => isAuthenticated, withFetchAppData),
);
